<template>
	<div class="template number" v-show="dataVal.IsShow || dataVal.IsShow == null" v-if="dataVal.Property.Title[0].Text!='流程条件'">
		<div class="panel_wrap">
			<label class="panel_title">{{dataVal.Property.Title[0].Text}}<span v-show="dataVal.Property.Require==1" class="require">*</span>
			</label>
			<input class="input_value" :change="changeVal(dataVal.Property.Title[0].Text)" v-model="dataVal.Value" type="text" :readOnly="dataVal.Disable"  :disabled="dataVal.Property.Title[0].Text=='流程条件'" />
		</div>
	</div>
</template>

<script>
	export default {
		props: ['dataVal'],
		data() {
			return {

			}
		},
		mounted() {

		},
		methods: {
			changeVal(val) {
				var value =this.dataVal.Value;
				if(this.dataVal.Property.Title[0].Text == '流程条件'){
					return;
				}
				if(value == null||value == -1){
					return;
				}
				if (this.dataVal.retain === undefined){
          this.dataVal.Value = (value.toString().match(/^\d{0,9}(\.\d{0,2}){0,1}/g)[0]) || null;
        }else if(this.dataVal.retain === 0){
          this.dataVal.Value = (value.toString().match(/^\d{0,9}(\\d{0,0}){0,1}/g)[0]) || null;
        }
				this.$emit('child-event', this.dataVal.Value, val);
			}
		}
	}
</script>

<style scoped>
	@import '../assets/css/common.css';
</style>
